export default __webpack_public_path__ + "static/media/014-explorer hat.43cfaa93.svg";